import React, { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { isNative } from '../../capacitor-init';
import WebVitalsDashboard from './WebVitalsDashboard';

const PERF_QUERY_KEY = 'perf';

/**
 * Floating Web Vitals panel for admins on web only.
 * Enable with URL query `?perf=1` (or `perf=true`). Remove query on close.
 */
export const AdminWebVitalsOverlay: React.FC = () => {
  const { isAdmin, user } = useAuth();
  const [searchParams, setSearchParams] = useSearchParams();

  const enabled = useMemo(() => {
    if (!user || !isAdmin || isNative()) {
      return false;
    }
    const v = searchParams.get(PERF_QUERY_KEY);
    return v === '1' || v === 'true';
  }, [user, isAdmin, searchParams]);

  const handleClose = () => {
    const next = new URLSearchParams(searchParams);
    next.delete(PERF_QUERY_KEY);
    setSearchParams(next, { replace: true });
  };

  if (!enabled) {
    return null;
  }

  return <WebVitalsDashboard visible onClose={handleClose} position="bottom-right" />;
};
